import { TEN_MINUTES_IN_MS, THREE_DAYS_IN_MS } from '@constants/constants';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withPrefix } from 'gatsby-link';
import { SetStateAction, useCallback, useState } from 'react';
import { useQuery } from 'react-query';

const rqOptions = {
    cacheTime: THREE_DAYS_IN_MS,
    staleTime: TEN_MINUTES_IN_MS,
};

const useGeoByAddress = (): {
    data: any;
    fetchGeo: (value: string) => void;
    status: 'idle' | 'error' | 'loading' | 'success'
} => {
    const [address, setAddress] = useState('');
    const { data, status } = useQuery(
        ['geo-by-address', address],
        async ({ queryKey }) => {
            const { 1: address } = queryKey;
            if (!address) {
                return {};
            }
            const apiUrl = withPrefix(`/api/geocode?address=${address}`);
            return (await fetch(apiUrl)).json();
        },
        rqOptions,
    );
    const fetchGeo = useCallback((value: SetStateAction<string>) => {
        setAddress(value);
    }, []);

    return { data, status, fetchGeo };
};

export default useGeoByAddress;
